"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconOffice365 = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    viewBox: "0 0 60 60",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "a",
        x1: "43.567",
        y1: "2.718",
        x2: "43.567",
        y2: "54.604",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0",
          stopColor: "#ffb900"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.166",
          stopColor: "#ef8400"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.313",
          stopColor: "#e25c01"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.429",
          stopColor: "#db4401"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.5",
          stopColor: "#d83b01"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "b",
        x1: "34.282",
        y1: "4.604",
        x2: "6.721",
        y2: "43.965",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0",
          stopColor: "#800600"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.6",
          stopColor: "#c72127"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.728",
          stopColor: "#c13959"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.847",
          stopColor: "#bc4b81"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.942",
          stopColor: "#b95799"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "1",
          stopColor: "#b85ba2"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "c",
        x1: "20.15",
        y1: "52.75",
        x2: "55.797",
        y2: "52.75",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0",
          stopColor: "#f32b44"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0.6",
          stopColor: "#a4070a"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "d",
        x1: "34.845",
        y1: "3.798",
        x2: "29.009",
        y2: "12.134",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0",
          stopOpacity: "0.4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "1",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: "e",
        x1: "44.385",
        y1: "53.552",
        x2: "28.414",
        y2: "52.155",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0",
          stopOpacity: "0.4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "1",
          stopOpacity: "0"
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M34.134,58.294l15.012-4.3A5.319,5.319,0,0,0,53,48.877V15.123a5.319,5.319,0,0,0-3.854-5.114l-15.012-4.3L38,15V47Z",
      fill: "url(#a)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M19.881,43.881l-5,2.786A2.608,2.608,0,0,1,11,44.388V20.1a5.325,5.325,0,0,1,2.7-4.63L30.024,6.2a5.34,5.34,0,0,1,2.636-.7h0A5.334,5.334,0,0,1,38,10.84V15L24.731,19.769A4.126,4.126,0,0,0,22,23.652V40.275A4.129,4.129,0,0,1,19.881,43.881Z",
      fill: "url(#b)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M38,47v6.16a5.334,5.334,0,0,1-5.34,5.34h0a5.34,5.34,0,0,1-2.636-.7L19.977,52.1A2.727,2.727,0,0,1,21.323,47Z",
      fill: "url(#c)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M19.881,43.881l-5,2.786A2.608,2.608,0,0,1,11,44.388V20.1a5.325,5.325,0,0,1,2.7-4.63L30.024,6.2a5.34,5.34,0,0,1,2.636-.7h0A5.334,5.334,0,0,1,38,10.84V15L24.731,19.769A4.126,4.126,0,0,0,22,23.652V40.275A4.129,4.129,0,0,1,19.881,43.881Z",
      fill: "url(#d)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M38,47v6.16a5.334,5.334,0,0,1-5.34,5.34h0a5.34,5.34,0,0,1-2.636-.7L19.977,52.1A2.727,2.727,0,0,1,21.323,47Z",
      fill: "url(#e)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      width: "64",
      height: "64",
      fill: "none"
    })]
  });
};
var _default = exports.default = (0, _withIcon.default)('IconOffice365')(IconOffice365);